<template>
  <div class="over-all-usage">
    <div class="flex-between">
      <div class="card">
        <div>整体提醒名单关爱率</div>
        <div class="flex-align-center" style="margin: 10px 0">
          <span class="num">{{ dataSource.dealRate }}%</span>
          <span style="margin: 0 10px; color: #ccc">(日标≥85%)</span>
          <span>
            <span style="color: #333; font-weight: 600">较上月</span>
            <span class="symbol">{{ dataSource.dealRateDiff >= 0 ? '↑' : '↓' }}</span>
            <span style="color: #51abf5">{{ Math.abs(dataSource.dealRateDiff || 0) }}%</span>
          </span>
        </div>
        <a-progress :percent="Number(dataSource.dealRate)" :showInfo="false" strokeColor="#1EAED2" />
      </div>
      <div class="card">
        <div>处理记录认真率</div>
        <div class="flex-align-center" style="margin: 10px 0">
          <span class="num" style="color: #fc7319">{{ dataSource.excellentDealRate }}%</span>
          <span style="margin: 0 10px; color: #ccc">(日标≥70%)</span>
          <span>
            <span style="color: #333; font-weight: 600">较上月</span>
            <span class="symbol">{{ dataSource.excellentDealRateDiff >= 0 ? '↑' : '↓' }}</span>
            <span style="color: #51abf5">
              {{ Math.abs(dataSource.excellentDealRateDiff || 0) }}%
            </span>
          </span>
        </div>
        <a-progress
          :percent="Number(dataSource.excellentDealRate)"
          :showInfo="false"
          strokeColor="#FC7319"
        />
      </div>
    </div>
    <div class="tip" style="margin: 12px 0 5px">
      <span>
        <img
          src="@/assets/imgs/school/monthRecord/warningMark.png"
          alt=""
          style="width: 14px; height: 14px; margin-right: 5px"
        />
        整体提醒名单关爱率达标，但处理记录认真率偏低，建议组织优秀班主任分享经验，开展专项培训，提升处理记录的规范性和详实度。
      </span>
    </div>
  </div>
</template>

<script>
import CountAnimation from '@/components/CountAnimation'

export default {
  name: 'OverallUsage',
  components: {
    CountAnimation,
  },
  props: {
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
<style scoped lang="less">
.over-all-usage {
  .card {
    width: calc(50% - 10px);
    padding: 15px;
    border: 1px solid #f1f2f5;
    border-radius: 10px;
    .num {
      font-size: 28px;
      font-weight: 600;
      color: #1eaed2;
    }
    .symbol {
      margin: 0 6px;
      font-size: 18px;
      font-weight: bold;
      color: #51abf5;
    }
  }
  .tip {
    padding: 15px;
    border-radius: 10px;
    line-height: 1.8;
    background-color: #fdfde5;
  }
}
</style>
